import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NbDialogModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { WellsComponent } from './wells.component';
import { WellsRoutingModule } from './wells-routing.module';
import { WellDetailsComponent } from './well-details/well-details.component';
import { WellListComponent } from './well-list/well-list.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { HighchartsChartModule } from 'highcharts-angular';
import { TreatmentDetailsComponent } from './treatment-details/treatment-details.component';
import { CompareMultipleWellComponent } from './compare-multiple-well/compare-multiple-well.component';
import { CompareParameterMultiWellsComponent } from './compare-parameter-multi-wells/compare-parameter-multi-wells.component';
import { CompareParameterSingleWellComponent } from './compare-parameter-single-well/compare-parameter-single-well.component';
import { CmwWellsSelectTreatmentsComponent } from './compare-multiple-well/cmw-wells-select-treatments/cmw-wells-select-treatments.component';
import { DataFilesComponent } from './data-files/data-files.component';
import { WdDiagnosticsPointsSelectComponent } from './well-details/wd-diagnostics-points-select/wd-diagnostics-points-select.component';
import { CompareMultipleWellDataService } from './compare-multiple-well/compare-multiple-well-data.service';
import { CompareMultipleWellNavigatorDataService } from './compare-multiple-well/compare-multiple-well-navigator-data.service';
import { CompareMultipleWellService } from './compare-multiple-well/compare-multiple-well.service';
import { CompareParameterSingleService } from './compare-parameter-single-well/compare-parameter-single-well.service';
// import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
  declarations: [
    WellsComponent,
    WellDetailsComponent,
    WellListComponent,
    TreatmentDetailsComponent,
    CompareMultipleWellComponent,
    CompareParameterMultiWellsComponent,
    CompareParameterSingleWellComponent,
    CmwWellsSelectTreatmentsComponent,
    DataFilesComponent,
    WdDiagnosticsPointsSelectComponent
  ],
  imports: [
    CommonModule,
    WellsRoutingModule,
    NgbPaginationModule,
    Ng2SmartTableModule,
    SharedModule,
    HighchartsChartModule,
    NbDialogModule.forRoot(),
    // LeafletModule
  ],
  providers: [
    CompareMultipleWellService,
    CompareMultipleWellDataService,
    CompareMultipleWellNavigatorDataService,
    CompareParameterSingleService
  ],
  entryComponents: []
})
export class WellsModule { }
